module.exports = __webpack_public_path__ + "assets/facebook-pixel.67ae5040.svg";